export default {
	"1630b6b6ad76b424e048fdb1a557976b": "Apple Pay",
	"eb0d5a7799b129f06512c166d0268563": "Google Pay",
	"e738a4caf17b913853b4a71a6bc9ef47": "Parameter error!",
	"397eb0a681632c476010ab12553d0647": "Signing the contract...",
	"a6d6b6694979b1225ca56e57a8ca4b80": "Payment in progress...",
	"7ec39eb7726bd374fca9faf82c2dc7ac": "Are you sure you want to give up paying?",
	"f382c25c78cd507886f788fc5ac67d02": "The payment result is being confirmed",
	"73fd929b5f73dd4b0671ab94ab824273": "Please do not make duplicate payments or leave this page"
}
